import { ChevronUp, ChevronDown } from "lucide-react";
import ProductPrices from './ProductPrices';
import CheckoutPayments from './CheckoutPayments';

const CartDetail = ({ cartSummary,promoAppliedValue, summary,expandedCarts, toggleCartVisibility }) => {
    
    return (
        <>
            <h6 className="text-2xl mb-32">Order Summary</h6>        
            {cartSummary?.length > 0 ? (
                <div>
                    {cartSummary.map((cart) => {
                        const locationName = cart.location?.name || "No location";
                        const isOpen       = expandedCarts[cart.id]; // Check if this cart is open

                        return (
                            <div key={cart.id} className="p-10 ">
                                {/* Location Header */}
                                {cart.lines && cart.lines.length > 0 ? (
                                    <div 
                                        className="text-lg font-semibold mb-2 capitalize cursor-pointer flex items-center justify-between w-full"
                                        onClick={() => toggleCartVisibility(cart.id)}
                                    >
                                        <div className='row'>
                                            <span className='col-md-11'><h6>{locationName}</h6></span>
                                            <span className="ml-auto flex items-center col-md-1">
                                                {isOpen ? <ChevronDown size={20} /> : <ChevronUp size={20} /> }
                                            </span>
                                        </div>                                    
                                    </div>
                                ): (
                                    <></>
                                )}

                                {/* Collapsible Section */}
                                {isOpen && (
                                    <div>
                                        {cart.lines && cart.lines.length > 0 ? (
                                            cart.lines.map((line) => {
                                                const productVariation = line.product_variation;
                                                const product = productVariation?.product;
                                                const brandName = product?.brand?.[0]?.name;
                                                const productName = product?.name;
                                                const quantity = line.quantity;

                                                let imageUrl = "";

                                                if(product?.jasani_image_url) {
                                                    imageUrl = product?.jasani_image_url;
                                                } else {
                                                    imageUrl = productVariation?.images?.[0]?.files?.small?.url;
                                                }

                                                return (
                                                    <div
                                                        key={productVariation?.id}
                                                        className="flex justify-between items-center mb-3 "
                                                    >
                                                        <div className='row bg-white mb-20 p-20'>
                                                            <div className='col-md-2'>
                                                                {imageUrl && (
                                                                    <img
                                                                        src={imageUrl}
                                                                        alt={productName}
                                                                        className="w-75 h-75 object-cover"
                                                                    />
                                                                )}
                                                            </div>
                                                            <div className='col-md-7'>
                                                                <p className="text-black">
                                                                    <b>{productName || "No product name"}</b>
                                                                </p>
                                                                {brandName && <p>{brandName}</p>}
                                                                <p>Quantity: {quantity}</p>
                                                            </div>
                                                            <div className='col-md-3 text-xl font-bold'>
                                                                <ProductPrices 
                                                                    productVariation = {productVariation}  
                                                                    quantity = {quantity}
                                                                />
                                                            </div>
                                                        </div>   
                                                    </div>
                                                );
                                            })
                                        ) : (
                                            // <p className="text-gray-500">No items in this location.</p>
                                            <></>
                                        )}
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            ) : (
                <p className="text-gray-500">No items in the cart.</p>
            )}
            {/* payment summary */}
            <div>
                <CheckoutPayments 
                    promoAppliedValue = {promoAppliedValue} 
                    summary = {summary}  
                />
            </div>
        </>
    );
};

export default CartDetail;
